<div class="c-navbar">
    <img src="../../../assets/logo_negativa.svg" alt="">
</div>
<div class="c-content">
    <mat-icon class="c-content__icon">warning</mat-icon>
    <h1 class="c-content__title">Ops, tivemos um problema com a sua solicitação</h1>
    <h3 class="c-content__subtitle">Acesso novamente o link e repita o processo.</h3>
</div>